import _createForOfIteratorHelper from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
export default {
  name: "im-send",
  data: function data() {
    return {
      userPhone: "",
      userList: [],
      message: "",
      imageUrl: "",
      sendImageMessagegDialogVisible: false,
      cardMessage: {
        type: 100,
        // 100：外链
        img: "",
        title: "",
        content: "",
        url: ""
      },
      sendCardMessageDialogVisible: false
    };
  },
  mounted: function mounted() {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    sendCardMessage: function sendCardMessage() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _iterator, _step, item, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!(!_this.cardMessage.img || !_this.cardMessage.title || !_this.cardMessage.content || !_this.cardMessage.url)) {
                _context2.n = 1;
                break;
              }
              _this.$message.error("请输入消息内容");
              return _context2.a(2);
            case 1:
              _this.userList.forEach(function (item) {
                item.status = 0;
              });
              _iterator = _createForOfIteratorHelper(_this.userList);
              _context2.p = 2;
              _iterator.s();
            case 3:
              if ((_step = _iterator.n()).done) {
                _context2.n = 6;
                break;
              }
              item = _step.value;
              _context2.n = 4;
              return _this.$api.sendMessage({
                toUserId: item.id,
                cardMsg: _this.cardMessage,
                type: _this.cardMessage.type
              });
            case 4:
              item.status = 1;
            case 5:
              _context2.n = 3;
              break;
            case 6:
              _context2.n = 8;
              break;
            case 7:
              _context2.p = 7;
              _t = _context2.v;
              _iterator.e(_t);
            case 8:
              _context2.p = 8;
              _iterator.f();
              return _context2.f(8);
            case 9:
              _this.$message.success("发送成功");
              _this.sendCardMessageDialogVisible = false;
            case 10:
              return _context2.a(2);
          }
        }, _callee2, null, [[2, 7, 8, 9]]);
      }))();
    },
    sendCardMessagegDialog: function sendCardMessagegDialog() {
      this.sendCardMessageDialogVisible = true;
    },
    goChatRecord: function goChatRecord(row) {
      window.open("#/im/chat/record?otherId=".concat(row.id));
    },
    convertImgToBase64: function convertImgToBase64(url, callback, outputFormat) {
      var canvas = document.createElement("CANVAS"),
        ctx = canvas.getContext("2d"),
        img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = function () {
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL(outputFormat || "image/png");
        callback.call(this, dataURL);
        canvas = null;
      };
      img.src = url;
    },
    sendImageMessage: function sendImageMessage() {
      var _this2 = this;
      if (!this.imageUrl) {
        return;
      }
      this.convertImgToBase64(this.imageUrl + "?imageView2/2/w/200", /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(res) {
          var base64, _iterator2, _step2, item, _t2;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.p = _context3.n) {
              case 0:
                base64 = res.split(",")[1];
                _this2.userList.forEach(function (item) {
                  item.status = 0;
                });
                _iterator2 = _createForOfIteratorHelper(_this2.userList);
                _context3.p = 1;
                _iterator2.s();
              case 2:
                if ((_step2 = _iterator2.n()).done) {
                  _context3.n = 5;
                  break;
                }
                item = _step2.value;
                _context3.n = 3;
                return _this2.$api.sendMessage({
                  toUserId: item.id,
                  msg: _this2.imageUrl,
                  type: 7,
                  base64: base64
                });
              case 3:
                item.status = 1;
              case 4:
                _context3.n = 2;
                break;
              case 5:
                _context3.n = 7;
                break;
              case 6:
                _context3.p = 6;
                _t2 = _context3.v;
                _iterator2.e(_t2);
              case 7:
                _context3.p = 7;
                _iterator2.f();
                return _context3.f(7);
              case 8:
                _this2.$message.success("发送成功");
                _this2.imageUrl = "";
                _this2.sendImageMessagegDialogVisible = false;
              case 9:
                return _context3.a(2);
            }
          }, _callee3, null, [[1, 6, 7, 8]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    sendImageMessagegDialog: function sendImageMessagegDialog() {
      this.sendImageMessagegDialogVisible = true;
    },
    sendMessage: function sendMessage() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _iterator3, _step3, item, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (_this3.message) {
                _context4.n = 1;
                break;
              }
              _this3.$message.error("请输入消息内容");
              return _context4.a(2, false);
            case 1:
              _this3.userList.forEach(function (item) {
                item.status = 0;
              });
              _iterator3 = _createForOfIteratorHelper(_this3.userList);
              _context4.p = 2;
              _iterator3.s();
            case 3:
              if ((_step3 = _iterator3.n()).done) {
                _context4.n = 6;
                break;
              }
              item = _step3.value;
              _context4.n = 4;
              return _this3.$api.sendMessage({
                toUserId: item.id,
                msg: _this3.message,
                type: 1
              });
            case 4:
              item.status = 1;
            case 5:
              _context4.n = 3;
              break;
            case 6:
              _context4.n = 8;
              break;
            case 7:
              _context4.p = 7;
              _t3 = _context4.v;
              _iterator3.e(_t3);
            case 8:
              _context4.p = 8;
              _iterator3.f();
              return _context4.f(8);
            case 9:
              _this3.$message.success("发送成功");
              _this3.message = "";
            case 10:
              return _context4.a(2);
          }
        }, _callee4, null, [[2, 7, 8, 9]]);
      }))();
    },
    getUserListByPhone: function getUserListByPhone() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var userPhone, res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              userPhone = [];
              if (_this4.userPhone) {
                userPhone = _this4.userPhone.split("\n");
              }
              userPhone = userPhone.filter(function (item) {
                return item;
              });
              _context5.n = 1;
              return _this4.$api.getUserListByPhone({
                userPhone: userPhone
              });
            case 1:
              res = _context5.v;
              res.data.forEach(function (item) {
                item.status = 0;
              });
              _this4.userList = res.data;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    }
  }
};